<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-scale-pulse-out" [fullScreen]="true">
	<p style="color: white" *ngIf="loadingMessage">{{loadingMessage}} </p>
	<p style="color: white" *ngIf="!loadingMessage">{{'LOADING' | translate}} </p>
</ngx-spinner>
<app-toasts></app-toasts>
<div id="wizard" [ngSwitch]="stepIndex">
	<app-info 
		[stepIndex]="stepIndex + 1"
		stepTotal="6"
		[title]="infoTitle"
		[subtext]="infoSubText">
	</app-info>
    <app-service-selection *ngSwitchCase="0"
        [config]="config"
        (onNext)="saveServiceSelection($event)"
        (onBack)="previousStep()">
    </app-service-selection>
    <app-otp #otp *ngSwitchCase="1"
        [serviceSelection]="serviceSelection"
        (onNext)="saveOtpAndSectionId($event)"
        (onBack)="previousStep()">
    </app-otp>
    <app-dynamic-form *ngSwitchCase="2"
        [formDataDto]="formDataTextDtos"
        (onNext)="saveTextData($event)"
        (onBack)="previousStep()">
    </app-dynamic-form>
	<app-dynamic-form *ngSwitchCase="3"
        [formDataDto]="formDataImageDtos"
		[savedImageIds]="imageIdList"
		[serviceSelection]="serviceSelection"
        (onNext)="saveImageData($event)"
        (onBack)="previousStep()"
		(onImageCaptured)="uploadImage($event)">
    </app-dynamic-form>
	<app-confirmation *ngSwitchCase="4"
		[texts]="capturedTexts"
        [images]="capturedImages"
        (onNext)="nextStep()"
        (onBack)="previousStep()">
    </app-confirmation>
	<app-summary *ngSwitchCase="5"
		[serviceSelection]="serviceSelection"
        [formData]="formData"
		(onBack)="previousStep()">
    </app-summary>
</div>